<nb-card>
  <div class="alert alert-danger" *ngIf="(serverError | async) === true || success === false" i18n="@@PasswordRecoveryError">Возникла ошибка</div>
  <div class="alert alert-warning" *ngIf="(userNotFoundError | async) === true" i18n="@@PhoneNotFound">Пользователь с таким номером не найден</div>
  <div class="alert alert-success" *ngIf="success" i18n="@@PasswordSuccessFullyChanged">Пароль успешно изменен</div>

  <form [formGroup]="forgotForm" novalidate (ngSubmit)="onSubmit()" *ngIf="!success">
    <div class="form-control-group">
      <label i18n="@@ForgotPasswordSmsHint">Укажите ваш номер телефона</label>
      <input phoneMask maxlength="18" formControlName="phone" nbInput id="resetInputEmail1" type="tel" fullWidth i18n-placeholder="@@PhoneNumber" placeholder="Только цифры" autocomplete="off">
    </div>
    <div *ngIf="attemptError" class="invalid-feedback" i18n="@@WaitFor">подождите {{ timeLeft | formatTime }} мин.</div>
    <div *ngIf="verifyError" class="invalid-feedback" i18n="@@WaitFor">{{ verifyErrorData }}</div>
    <div *ngIf="counterStarted" class="invalid-feedback" i18n="@@NextVerificationUntil">вам отправлен sms с кодом. повторная проверка возможна через <span class="badge text-bg-primary">{{ counter | formatTime }}</span></div>
    <div *ngIf="forgotForm.controls.phone.errors?.required && forgotForm.controls.phone.touched" class="invalid-feedback" i18n>укажите номер телефона</div>

    <div class="form-control-group" *ngIf="smsCodeFieldOpened">
      <div class="form-control-group">
        <input nbInput id="signupInputCode" formControlName="smsCode" i18n-placeholder="@@SmsCode" placeholder="Код из смс *" required>
        &nbsp;<button [disabled]="!forgotForm.controls.smsCode.valid" (click)="checkSmsCode()" type="button" nbButton size="tiny" status="warning">подтвердить код
        <nb-icon *ngIf="(codeValidated | async ) === true" icon="checkmark-circle-outline" status="success"></nb-icon>
        <nb-icon *ngIf="(codeValidated | async ) === false" icon="alert-circle-outline" status="danger"></nb-icon>
      </button>

      </div>
      <div *ngIf="(codeValidated | async) === false" class="invalid-feedback" i18n="@@CodeInvalid">не верный код</div>
      <div *ngIf="(codeValidated | async ) === true" class="valid-feedback" i18n="@@CodeVerified">код проверен</div>
      <div *ngIf="forgotForm.controls.smsCode.invalid && forgotForm.controls.smsCode.touched" class="invalid-feedback" i18n="@@SmsCodeNotValid">код не верен</div>
    </div>

    <div class="form-control-group" *ngIf="codeValidated | async">
      <div class="form-control-group">
        <input nbInput type="password" formControlName="password" i18n-placeholder="@@Password" placeholder="Введите пароль *" required>
      </div>
      <div class="invalid-feedback"
           *ngIf="forgotForm.controls.password.errors?.minlength && forgotForm.controls.password.touched" i18n="@@PasswordTooShort">
        пароль слишком короткий
      </div>
      <div class="invalid-feedback"
           *ngIf="forgotForm.controls.password.errors?.required && forgotForm.controls.password.touched" i18n="@@PasswordIsEmpty">
        укажите пароль
      </div>

      <div class="form-control-group" style="margin-top: 18px">
        <input nbInput type="password" formControlName="repeatPassword" i18n-placeholder="@@PasswordRepeat" placeholder="Повторите пароль *" required>
      </div>
      <div class="invalid-feedback"
           *ngIf="forgotForm.controls.repeatPassword.errors?.minlength && forgotForm.controls.repeatPassword.touched" i18n="@@PasswordTooShort">
        пароль слишком короткий
      </div>
      <div class="invalid-feedback"
           *ngIf="forgotForm.controls.repeatPassword.errors?.required && forgotForm.controls.repeatPassword.touched" i18n="@@RepeatPasswordIsEmpty">
        подтвердите пароль
      </div>
      <div class="invalid-feedback" style="margin-left: 40%" *ngIf="!(isValidPassFields | async) && forgotForm.touched" i18n="@@PasswordsAreNotIdentical">пароли не совпадают</div>
    </div>
    <nb-card-footer>
      <button [hidden]="!(isValidForm | async) || !(codeValidated | async)" nbButton type="submit" i18n="@@ChangePassword" status="primary" size="large">Изменить пароль</button>
      <button (click)="checkNumber()" [disabled]="!forgotForm.controls.phone.valid || forgotForm.controls.phone.disabled" nbButton size="large" type="button" status="primary" i18n="@@SendCode">Выслать код</button>
    </nb-card-footer>
  </form>
</nb-card>
